import { Image, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { borderRadius } from "ThemeCustom";
import { FetchFileFromS3 } from "Utility/Helpers/Storage";

function UploadProfilePic({
  S3Key,
  src = null,
  className,
  imagePreviewStyle,
  ...rest
}) {
  const [imageURL, setImageURL] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (S3Key) {
        await fetchURL(S3Key);
      }
    })();
  }, [S3Key]);

  const fetchURL = async (key) => {
    setIsLoading(true);
    try {
      const url = await FetchFileFromS3(key);
      setImageURL(url);
    } catch (error) {
      console.error("Failed to fetch image from S3:", error);
      setImageURL(null); // Optional: Display a placeholder or error image
    } finally {
      setIsLoading(false);
    }
  };

  const getImagePath = () => (src ? src : imageURL);

  return (
    <div className={"flex items-center justify-center"}>
      {isLoading ? (
        <Skeleton.Image
          active
          style={{
            width: "184px",
            height: "184px",
            borderRadius: `${borderRadius}`,
          }}
        />
      ) : (
        <Image
          {...rest}
          preview={false}
          src={getImagePath()}
          className={`${imagePreviewStyle} ${className}`}
          style={{
            objectFit: "cover", // Ensure the image is fully visible
            width: "184px",
            height: "184px",
            maxWidth: "184px", // Take full width of the container
            maxHeighteight: "184px", // Take full height of the container
            borderRadius: "1rem",
          }}
        />
      )}
    </div>
  );
}

export default UploadProfilePic;
